package horcrux.common.api.dtos

import arrow.core.Either
import arrow.core.NonEmptyList
import arrow.core.raise.either
import horcrux.common.HorcruxRequestError
import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.NonEmptyListSerializer
import horcrux.common.api.APILimits
import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.api.dtos.types.DocumentIdentifier
import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.common.api.dtos.types.DocumentType
import horcrux.common.api.dtos.types.EmbeddingModelConfigs
import horcrux.common.api.dtos.types.ProcessedDocument
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable

enum class PostDocumentsRequestType {
    PROCESS_DOCUMENTS_AND_GENERATE_EMBEDDINGS, PROCESS_DOCUMENTS;
}

object DocumentIdentifiersSerializer : NonEmptyListSerializer<DocumentIdentifier> {
    override val elementSerializer: KSerializer<DocumentIdentifier> = DocumentIdentifier.serializer()
}

@Serializable
enum class DocumentChunkerType {
    TEXT, IMAGE, COMPOSITE;
}

@Serializable
data class PostDocumentsRequest(
    val collectionID: CollectionID,
    @Serializable(DocumentIdentifiersSerializer::class) val documentIdentifiers: NonEmptyList<DocumentIdentifier>,
    val embeddingModelConfigs: EmbeddingModelConfigs,
    val postDocumentsRequestType: PostDocumentsRequestType,
    val documentChunkerTypeMaybe: DocumentChunkerType? = null,
) : HorcruxRequest {
    fun getDocumentChunkerType(documentType: DocumentType): DocumentChunkerType =
        documentChunkerTypeMaybe ?: documentType.defaultDocumentChunkerType

    override fun validate(): Either<Throwable, PostDocumentsRequest> = either {
        if (documentIdentifiers.size > APILimits.MAX_POST_DOCUMENTS_BATCH_SIZE) {
            raise(TooManyDocumentsError(documentIdentifiers.size))
        }
        this@PostDocumentsRequest
    }
}

@Serializable
sealed interface PostDocumentResponseData

@Serializable
data class ProcessDocumentsAndGenerateEmbeddingsResponse(
    val documentMetadata: DocumentMetadata,
) : PostDocumentResponseData

@Serializable
data class ProcessDocumentsResponse(
    val documentMetadata: DocumentMetadata,
    val processedDocument: ProcessedDocument,
) : PostDocumentResponseData

object PostDocumentResponseDataListSerializer : NonEmptyListSerializer<PostDocumentResponseData> {
    override val elementSerializer: KSerializer<PostDocumentResponseData> = PostDocumentResponseData.serializer()
}

@Serializable
data class PostDocumentsResponse(
    @Serializable(PostDocumentResponseDataListSerializer::class) val postDocumentResponseDataList: NonEmptyList<PostDocumentResponseData>,
) : HorcruxResponse

sealed interface PostDocumentsError : HorcruxRequestError

data class TooManyDocumentsError(
    val numDocuments: Int,
) : PostDocumentsError,
    HorcruxRequestSimpleError(HttpStatusCode.BadRequest)
